import { parse } from 'date-fns'
import { getNestedProperty } from '@opallabs/lambda'
import { jsonApiWrapper } from '../../../jsonApiParser'

export const getNotifications = (state) =>
  getNestedProperty(state, 'jsonApiEntities', 'notifications') || {}

export const getDownloads = (state) =>
  getNestedProperty(state, 'downloads') || []

export const mapPersonalPanelNotifications = (state) => {
  const notifications = getNotifications(state)

  return Object.values(notifications).map((notification) => {
    const wrappedNotification = jsonApiWrapper({ data: notification, state })
    return {
      createdAt: parse(
        wrappedNotification.timestamp,
        'yyyy-MM-dd HH:mm:ss xx',
        new Date()
      ),
      id: wrappedNotification.id,
      read: wrappedNotification.read,
      referencedObjects: wrappedNotification.referenced_objects,
      seen: wrappedNotification.seen,
      supplementalText: wrappedNotification.supplemental_text,
      timeFormat: 'PPP',
      timestamp: parse(
        wrappedNotification.timestamp,
        'yyyy-MM-dd HH:mm:ss xx',
        new Date()
      ),
      type: wrappedNotification.public_type,
      collaborationThreadId: wrappedNotification.collaboration_thread_id,
    }
  })
}

export const mapPersonalPanelDownloads = (state) => {
  const downloads = getDownloads(state)
  return downloads.map((download) => ({
    createdAt: parse(download.timestamp, 'yyyy-MM-dd HH:mm:ss xx', new Date()),
    downloadUrl: download.download_url,
    id: download.id,
    read: download.read,
    referencedObjects: download.referenced_objects,
    seen: download.seen,
    supplementalText: download.supplemental_text,
    timeFormat: 'PPP',
    timestamp: parse(download.timestamp, 'yyyy-MM-dd HH:mm:ss xx', new Date()),
    type: download.public_type,
  }))
}
